// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"pricing-module--cardsContainer--2C72J","pricingSection":"pricing-module--pricingSection--39dQT","faqContainer":"pricing-module--faqContainer--IBvqp"};